/**
 * Все валюты в JSON
 */
export const jsonCurrencies = (window.app && window.app.jsonCurrencies) || [{
  'id': 1,
  'name': 'RUB',
  'rate': '1',
  'plus': null,
  'sign': '<span class=\'rur\'>руб.</span>',
  'is_round_needed': null,
  'grapheme': '₽',
}, {
  'id': 2,
  'name': 'USD',
  'rate': '62.7908',
  'plus': null,
  'sign': '$',
  'is_round_needed': null,
  'grapheme': '$',
}, {
  'id': 3,
  'name': 'EUR',
  'rate': '73.4087',
  'plus': null,
  'sign': '&euro;',
  'is_round_needed': null,
  'grapheme': '€',
}, {
  'id': 4,
  'name': 'BYN',
  'rate': '31.482',
  'plus': null,
  'sign': 'Br',
  'is_round_needed': null,
  'grapheme': 'Br',
}, {
  'id': 5,
  'name': 'UAH',
  'rate': '2.39751',
  'plus': null,
  'sign': '₴',
  'is_round_needed': null,
  'grapheme': '₴',
}, {
  'id': 6,
  'name': 'KZT',
  'rate': '0.171899',
  'plus': null,
  'sign': '〒',
  'is_round_needed': null,
  'grapheme': '〒',
}]
